import React from 'react';
import HrnbModal from '../../../components/controls/HrnbModal';
import HrnbInput from '../../../components/controls/HrnbInput';
import HrnbButton from '../../../components/controls/HrnbButton';
import HrnbLoader from '../../../components/controls/HrnbLoader';

/**
 * Модалка редактирования регламента баттла
 */
const RegulationModal = ({
  isOpen,
  onClose,
  regulationForm,
  regulationActionLoading,
  onFormChange,
  onAddRule,
  onUpdateRule,
  onRemoveRule,
  onAddLimitation,
  onUpdateLimitation,
  onRemoveLimitation,
  onSave,
}) => {
  return (
    <HrnbModal
      open={isOpen}
      onClose={onClose}
      title="Редактирование регламента баттла"
      size="large"
    >
      <form onSubmit={onSave} className="regulation-form">
        <div className="form-row">
          <HrnbInput
            label="Возрастное ограничение"
            value={regulationForm.ageLimits || ''}
            onChange={(e) =>
              onFormChange('ageLimits', typeof e === 'string' ? e : e.target.value)
            }
            placeholder="например, 18+"
          />
        </div>

        <div className="form-row">
          <HrnbInput
            label="Форматы"
            value={regulationForm.formats || ''}
            onChange={(e) =>
              onFormChange('formats', typeof e === 'string' ? e : e.target.value)
            }
            placeholder="например, mp3, wav"
          />
        </div>

        {/* Правила */}
        <div className="form-row">
          <div className="regulation-section-header">
            <h5>Правила</h5>
            <HrnbButton
              variant="outline-primary"
              size="sm"
              type="button"
              onClick={onAddRule}
            >
              + Добавить правило
            </HrnbButton>
          </div>

          {regulationForm.rules.map((rule, index) => (
            <div key={index} className="regulation-field-row">
              <HrnbInput
                placeholder="Название правила"
                value={rule.title}
                onChange={(e) =>
                  onUpdateRule(
                    index,
                    'title',
                    typeof e === 'string' ? e : e.target.value
                  )
                }
                className="regulation-field-title"
              />
              <HrnbInput
                placeholder="Описание (необязательно)"
                value={rule.description || ''}
                onChange={(e) =>
                  onUpdateRule(
                    index,
                    'description',
                    typeof e === 'string' ? e : e.target.value
                  )
                }
                className="regulation-field-desc"
              />
              <HrnbButton
                variant="outline-danger"
                size="sm"
                type="button"
                onClick={() => onRemoveRule(index)}
              >
                ×
              </HrnbButton>
            </div>
          ))}

          {regulationForm.rules.length === 0 && (
            <p className="text-muted">
              Нет правил. Нажмите "+ Добавить правило".
            </p>
          )}
        </div>

        {/* Ограничения */}
        <div className="form-row">
          <div className="regulation-section-header">
            <h5>Ограничения</h5>
            <HrnbButton
              variant="outline-primary"
              size="sm"
              type="button"
              onClick={onAddLimitation}
            >
              + Добавить ограничение
            </HrnbButton>
          </div>

          {regulationForm.limitations.map((lim, index) => (
            <div key={index} className="regulation-field-row">
              <HrnbInput
                placeholder="Название ограничения"
                value={lim.title}
                onChange={(e) =>
                  onUpdateLimitation(
                    index,
                    'title',
                    typeof e === 'string' ? e : e.target.value
                  )
                }
                className="regulation-field-title"
              />
              <HrnbInput
                placeholder="Описание (необязательно)"
                value={lim.description || ''}
                onChange={(e) =>
                  onUpdateLimitation(
                    index,
                    'description',
                    typeof e === 'string' ? e : e.target.value
                  )
                }
                className="regulation-field-desc"
              />
              <HrnbInput
                placeholder="Значение (необязательно)"
                value={lim.value || ''}
                onChange={(e) =>
                  onUpdateLimitation(
                    index,
                    'value',
                    typeof e === 'string' ? e : e.target.value
                  )
                }
                className="regulation-field-value"
              />
              <HrnbButton
                variant="outline-danger"
                size="sm"
                type="button"
                onClick={() => onRemoveLimitation(index)}
              >
                ×
              </HrnbButton>
            </div>
          ))}

          {regulationForm.limitations.length === 0 && (
            <p className="text-muted">
              Нет ограничений. Нажмите "+ Добавить ограничение".
            </p>
          )}
        </div>

        <div className="form-actions">
          <HrnbButton variant="outline" onClick={onClose} type="button">
            Отмена
          </HrnbButton>
          <HrnbButton
            variant="primary"
            type="submit"
            disabled={regulationActionLoading}
          >
            {regulationActionLoading ? (
              <HrnbLoader size="sm" />
            ) : (
              'Сохранить регламент'
            )}
          </HrnbButton>
        </div>
      </form>
    </HrnbModal>
  );
};

export default RegulationModal;
